
<form *ngIf="websiteName == 'Major'" class="example-form" (ngSubmit)="ndcSearchSubmit()" #packageInsertForm="ngForm">
  <div class="main-container">
    <h1 class="header-text" style="font-weight: normal !important;">Package Inserts</h1>
    <mat-label class="ndctext">Search using NDC# (Example: 00904-5711-35)</mat-label><br>
    <div class="ndcinput form-element">
      <input placeholder="Enter NDC number"  type="text" id="ndc"  name="ndc" required #ndc="ngModel" 
            maxlength="13" [(ngModel)]="NDCNumber">
      <mat-error *ngIf="ndc.errors?.required && packageInsertForm.submitted">Required Field</mat-error>        
    </div>
    <button id="submit" class="search-btn" type="submit" mat-raised-button color="accent">Search
      <img src="../../../../assets/images/Major/Arrow_right_btn_icon.png" />
    </button>
    <div *ngIf="isPackageNotFound">
      No package insert found.
    </div>
    <div *ngIf="isValidNdcLength" class="ndcLength">
      NDC must be 11 characters long.
    </div>
  </div>
  </form>